/* Velocity theme JS */
(function () {
  'use strict';

  /* Mobile nav */
  document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nav = document.querySelector('[data-nav]');
      if (nav) nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', nav && nav.classList.contains('is-open'));
    });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.closest('.qty').querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(btn.dataset.qtyChange, 10);
    if (val < 1) val = 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product page */
  var productEl = document.querySelector('[data-product]');
  if (productEl) initProduct(productEl);

  function initProduct(root) {
    var dataScript = root.querySelector('[data-product-json]');
    var product = dataScript ? JSON.parse(dataScript.textContent) : null;
    var form = root.querySelector('form[data-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var moneyFormat = root.dataset.moneyFormat || '{{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      if (amount.endsWith('.00')) amount = amount.slice(0, -3);
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }

    /* Gallery */
    var mainImg = root.querySelector('[data-main-image]');
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) { mainImg.src = thumb.dataset.src; mainImg.srcset = ''; }
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* Variant selection */
    function currentOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.dataset.optionIndex, 10);
        var checked = group.querySelector('input:checked');
        var select = group.matches('select') ? group : null;
        opts[idx] = checked ? checked.value : (select ? select.value : null);
      });
      return opts;
    }

    function onVariantChange() {
      if (!product) return;
      var opts = currentOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      var atcBtn = root.querySelector('[data-atc]');
      var priceCur = root.querySelectorAll('[data-price-current]');
      var priceCmp = root.querySelectorAll('[data-price-compare]');
      var priceSave = root.querySelectorAll('[data-price-save]');

      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (atcBtn) {
        atcBtn.disabled = !variant.available;
        atcBtn.textContent = variant.available ? (atcBtn.dataset.atcText || 'Add to cart') : 'Sold out';
      }
      priceCur.forEach(function (el) { el.textContent = formatMoney(variant.price); });
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceCmp.forEach(function (el) {
        el.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
        el.style.display = hasCompare ? '' : 'none';
      });
      priceSave.forEach(function (el) {
        if (hasCompare) {
          var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
          el.textContent = 'Save ' + pct + '%';
          el.style.display = '';
        } else { el.style.display = 'none'; }
      });
      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image.src; mainImg.srcset = '';
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      group.addEventListener('change', onVariantChange);
    });

    /* Sticky ATC */
    var sticky = document.querySelector('[data-sticky-atc]');
    var buyBox = root.querySelector('[data-buy-buttons]');
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(buyBox);
      var stickyBtn = sticky.querySelector('[data-sticky-submit]');
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      }
    }

    /* Countdown (evergreen, per visitor session) */
    root.querySelectorAll('[data-countdown]').forEach(function (cd) {
      var minutes = parseInt(cd.dataset.countdown, 10) || 15;
      var key = 'velocity_cd_' + (product ? product.id : 'x');
      var end = sessionStorage.getItem(key);
      if (!end || parseInt(end, 10) < Date.now()) {
        end = Date.now() + minutes * 60000;
        sessionStorage.setItem(key, end);
      }
      end = parseInt(end, 10);
      var h = cd.querySelector('[data-cd-h]'), m = cd.querySelector('[data-cd-m]'), s = cd.querySelector('[data-cd-s]');
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var hh = Math.floor(diff / 3600000);
        var mm = Math.floor((diff % 3600000) / 60000);
        var ss = Math.floor((diff % 60000) / 1000);
        if (h) h.firstChild.textContent = String(hh).padStart(2, '0');
        if (m) m.firstChild.textContent = String(mm).padStart(2, '0');
        if (s) s.firstChild.textContent = String(ss).padStart(2, '0');
        if (diff <= 0) {
          end = Date.now() + minutes * 60000;
          sessionStorage.setItem(key, end);
        }
      }
      tick();
      setInterval(tick, 1000);
    });
  }
})();

/* ===== v3: gallery arrows + live social proof ===== */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-product]');
    if (!root) return;

    /* Gallery prev/next cycling through thumbnails */
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var mainImg = root.querySelector('[data-main-image]');
    function activeIndex() {
      for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('is-active')) return i;
      return 0;
    }
    function goTo(i) {
      if (!thumbs.length || !mainImg) return;
      var n = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[n].classList.add('is-active');
      mainImg.src = thumbs[n].dataset.src;
      mainImg.removeAttribute('srcset');
    }
    var prev = root.querySelector('[data-gal-prev]');
    var next = root.querySelector('[data-gal-next]');
    if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });

    /* Swipe on main image (mobile) */
    if (mainImg && thumbs.length > 1) {
      var sx = null;
      mainImg.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      mainImg.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) goTo(activeIndex() + (dx < 0 ? 1 : -1));
        sx = null;
      }, { passive: true });
    }

    /* Live viewers count: small realistic fluctuation */
    var v = root.querySelector('[data-viewers-count]');
    if (v) {
      var base = parseInt(v.textContent, 10) || 12;
      setInterval(function () {
        var delta = Math.random() < 0.5 ? -1 : 1;
        base = Math.max(6, Math.min(34, base + delta));
        v.textContent = base;
      }, 6000 + Math.random() * 4000);
    }
  });
})();
